import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowUpOnSquareIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrow-up-on-square"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M16.5001 8.40001H12.9L12.9 4.39189L15.2405 6.91242C15.5788 7.27666 16.1482 7.29775 16.5125 6.95953C16.8767 6.6213 16.8978 6.05185 16.5596 5.68761L12.6596 1.48761C12.4893 1.30422 12.2503 1.20001 12 1.20001C11.7498 1.20001 11.5108 1.30422 11.3405 1.48761L7.44053 5.6876C7.10231 6.05184 7.1234 6.6213 7.48764 6.95953C7.85188 7.29775 8.42134 7.27666 8.75956 6.91242L11.1 4.39189L11.1 8.40001H7.50005C6.00888 8.40001 4.80005 9.60884 4.80005 11.1V20.1C4.80005 21.5912 6.00888 22.8 7.50005 22.8H16.5001C17.9912 22.8 19.2001 21.5912 19.2001 20.1V11.1C19.2001 9.60884 17.9912 8.40001 16.5001 8.40001ZM12.9 8.40001H11.1L11.1001 14.7C11.1001 15.1971 11.503 15.6 12.0001 15.6C12.4971 15.6 12.9001 15.1971 12.9001 14.7L12.9 8.40001Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowUpOnSquareIcon;